import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { createStructuredSelector } from 'reselect';
import {
    WorksheetPageIndex,
    WorksheetEntitySummaryIndex
} from 'services/worksheet/types';
import { makeSelectTanksEstimated } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    entitySummaryIndex: WorksheetEntitySummaryIndex;
}

interface ConnectedProps {
    tanksEstimated: number;
}

type Props = OwnProps & ConnectedProps;

export class TanksEstimatedTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { tanksEstimated } = this.props;

        return <TableCell>{tanksEstimated}</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    tanksEstimated: makeSelectTanksEstimated()
});

export default connect(mapStateToProps)(TanksEstimatedTableCellComponent);
